<template>
  <div id="body">
    <router-view />
  </div>
</template>

<style>
body{
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}

#app{
  font-family: Avenir, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  margin-top: 0px;
}

.title-component{
    padding: 30px 0 10px 0;
}
</style>
